import { render, staticRenderFns } from "./RegisterVerification.vue?vue&type=template&id=6c52a074&scoped=true&"
import script from "./RegisterVerification.vue?vue&type=script&lang=js&"
export * from "./RegisterVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c52a074",
  null
  
)

export default component.exports